import { keepPreviousData, useQuery } from "@tanstack/react-query"
import { useTRPC } from "utils/trpc"

export const useMetricProjectAvailability = ({
  dataIds,
  productIds,
}: {
  dataIds: string[]
  productIds?: string[]
}) => {
  const trpc = useTRPC()

  return useQuery(
    trpc.metrics.getProjectAvailability.queryOptions(
      {
        data_ids: dataIds,
        product_ids: productIds,
      },
      { enabled: !!dataIds.length, placeholderData: keepPreviousData }
    )
  )
}
